/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';
import StepContent from '@material-ui/core/StepContent';
import { Paper, Typography, Divider, TextField, Button, IconButton, Tooltip, CircularProgress, Grid } from '@material-ui/core'

import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Clear from '@material-ui/icons/Clear'
import Add from '@material-ui/icons/Add'

import FDropDown from '../../../fluid/Elements/Inputs/FDropDown'
import Actions from '../../../fluid/Actions/ActionFactory';

import AddWorldViewServer from '../../WVServer/AddWorldViewServer';

import { v4 as uuidv4 } from 'uuid';

const clone = require('rfdc')()

const styles = theme => ({
    text_field : {
        width : '100%',
        marginTop : '10px'
    }
})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
          main: '#f50157',
        },
      },
})

function getSteps() {
    return ['Select World View Server', 'World View Fields'];
}

class SetSecurityCredentails extends Component {
    state = {
        fields : [],
        error_message : "",
        script_details: null,
        security_fields : null,
        edit_mode: false
    }

    headingPanel = React.createRef()

    componentWillMount () {
        this.getFields();
    }

    componentDidMount () {
        const content_height = this.props.maxHeight - this.headingPanel.current.clientHeight
        this.setState({...this.state, content_height : 700, script_details: this.props.script_details, edit_mode : this.props.edit_mode }, () => {
           
        })

        
    }

    getFields = () => {
        Actions('http_request', {
            url : '/sainapse/bot/securitycredentials',
            method : 'get',
            data : {}
        }).then(res => {
            this.setState({...this.state, security_fields: res.data.result }, () => {
                this.populateMandatoryFields();
                this.setState({ isLoading: false})
            })
        }).catch(err => {
            console.log("error")
            console.log(err)
        })
    }

    populateMandatoryFields = () => {
        // Security fields are from api
        let { security_fields, edit_mode } = this.state;
        let fields = [];

        if( security_fields.length > 0 ){
            fields = security_fields.map((element) => {
                let new_id = uuidv4()
                let field = {
                    id : new_id,
                    name : element,
                    data_type : "",
                    name_error : false,
                    data_type_error : false,
                    name_error_message : "",
                    data_type_error_message : "",
                    value: "",
                    // value_error_message: false,
                    value_error_message: ""
                }

                let field_name = element;
                if(edit_mode == true){
                    let { script_details } = this.state;
                    let { security_credentials } = script_details;
                    if( security_credentials.hasOwnProperty(field_name) ){
                        field.value = security_credentials[field_name];
                    }   
                }
                return field;
            })
        }

        this.setState({...this.state, fields: fields}, () => {
           
        })
    }

    handleChange = (state_key, value) => {
        console.log('JSON Output: ', value)
        this.setState({...this.state,
            [state_key]: value
        })
    }

    handleStep = (step) => {
        this.setState({...this.state, activeStep : step})
    }

    handleNext = () => {
        this.setState({...this.state, activeStep : this.state.activeStep === this.state.steps.length - 1 ? this.state.activeStep :this.state.activeStep + 1})
    };
    
    handleBack = () => {
        this.setState({...this.state, activeStep : this.state.activeStep === 0 ? this.state.activeStep : this.state.activeStep - 1})
    };


    renderFields = () => {
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    <div style={{ marginBottom: "5px"}}></div>
                    <Typography variant = 'body22' style={{ marginTop: "5px !important"}} ><em style={{ padding: "10px"}}>Add Security Credentials to the Script to Proceed.</em></Typography>
                    <Divider style = {{width : '100%', marginTop : '10px', marginBottom : '5px'}} />
                    <Grid container xs = {12} spacing = {0} direction = 'row' wrap = 'wrap' alignItems = 'center'>
                        {this.generateFields()}
                        <Grid item xs = {3}>
                            <IconButton 
                                style = {{display : 'block'}} 
                                color = 'primary' 
                                size = 'small'
                                onClick = {this.addField}
                            >
                                <Add/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </ThemeProvider>
            </Fragment>
        )
    }

    handleFieldChange = (key, value, id) => {
        let new_state = clone(this.state)
        let index = new_state.fields.findIndex(field => field.id === id)
        let fields = new_state.fields

        fields[index][key[0]] = value

        this.setState({...new_state})
    }

    validateField = (id, key) => {

        if (key === 'name') {
            let field_index = this.state.fields.findIndex(field => field.id === id)
            let field_name = this.state.fields[field_index].name

            if (field_name !== "") {
                let similar_name_index = this.state.fields.findIndex(field => field.name === field_name)
                if (similar_name_index !== -1 && similar_name_index !== field_index) {
                    let fields = [...this.state.fields]
                    fields[field_index].name_error = true
                    fields[field_index].name_error_message = "Field Name already exists"

                    this.setState({...this.state, fields : fields})
                } else {
                    let fields = [...this.state.fields]
                    fields[field_index].name_error = false
                    fields[field_index].name_error_message = ""

                    this.setState({...this.state, fields : fields})
                }
            }
        } else if (key === 'data_type') {
            let field_index = this.state.fields.findIndex(field => field.id === id)

            if (this.state.fields[field_index].data_type === "") {
                let fields = [...this.state.fields]
                fields[field_index].data_type_error = true
                fields[field_index].data_type_error_message = "Field Type cannot be empty"

                this.setState({...this.state, fields : fields})
            } else {
                let fields = [...this.state.fields]
                fields[field_index].data_type_error = false
                fields[field_index].data_type_error_message = ""

                this.setState({...this.state, fields : fields})
            }
        }
    }


    generateFields = () => {
        let fields = this.state.fields.map((field, index) => {
            return (
                <Grid item xs = {3}>
                    <Paper elevation = {3} style = {{margin : '5px', padding : '5px'}}>
                        <div style = {{display : 'flex', flexDirection : 'row-reverse'}}>
                            <IconButton size = 'small' color = 'secondary' onClick = {() => this.removeField(field.id)}>
                                <Clear fontSize = 'small'/>
                            </IconButton>
                        </div>
                        <TextField
                            style = {{width : '100%'}}
                            key = {field.id + 'name'}
                            label = 'Field Name'
                            helperText = {field.name_error === true ? field.name_error_message : 'Name of the Field'}
                            error = {field.name_error}
                            value = {field.name}
                            autoFocus
                            onChange = {(event) => this.handleFieldChange(["name"], event.target.value, field.id)}
                            onBlur = {() => this.validateField(field.id, 'name')}
                        />
                        <TextField
                            style = {{width : '100%'}}
                            key = {field.id + 'value'}
                            label = 'Field Value'
                            helperText = {field.name_error === true ? field.value_error_message : 'Value of the Field'}
                            error = {field.value_error}
                            value = {field.value}
                            autoFocus
                            onChange = {(event) => this.handleFieldChange(["value"], event.target.value, field.id)}
                            onBlur = {() => this.validateField(field.id, 'value')}
                        />

                    </Paper>
                </Grid>
            )
        })

        return fields
    } 


    addField = () => {
        let new_id = uuidv4()
        let new_field = {
            id : new_id,
            name : "",
            data_type : "",
            name_error : false,
            data_type_error : false,
            name_error_message : "",
            data_type_error_message : "",
            value: "",
            value_error_message: false,
            // value_error_message: ""
        }

        let fields = [...this.state.fields]
        fields.push(new_field)

        this.setState({...this.state, fields: fields}, () => console.log('WV State :', this.state))
    }

    removeField = (id) => {
        let fields = [...this.state.fields]

        let index = fields.findIndex(field => field.id === id)

        fields.splice(index, 1)

        this.setState({...this.state, fields: fields})
    }

    validateAndProceed = () => {
        let new_state = clone(this.state)

        let fields = new_state.fields

        let name_error = false
        let value_error = false

        let empty_name_index = fields.findIndex(field => field.name === "")
        let empty_value_index = fields.findIndex(field => field.value === "")

        if (empty_name_index !== -1) {
            console.log('Error in Name at :', empty_name_index)
            name_error = true
            fields[empty_name_index].name_error = true
            fields[empty_name_index].name_error_message = "Field Name cannot be empty"
        }

        if (empty_value_index !== -1) {
            console.log('Error in Value at :', empty_value_index)
            value_error = true
            fields[empty_value_index].value_error = true
            fields[empty_value_index].value_error_message = "Field Value cannot be empty"
        }

        if (name_error || value_error) {
            this.setState({...this.state, fields: fields})
        } else {
            let security_credentials = {}
            let fields = this.state.fields
            fields.forEach((field, index) => {   
                security_credentials[field.name] = field.value;
            })

            let script_details = this.props.script_details;
            script_details.security_credentials = security_credentials
            this.props.handleNext({ 
                script_name: this.props.script_name, 
                script_details : this.props.script_details
            })
        }
    }


    renderNavButtons = (state_key) => {
        if (this.state[state_key]) {
            return (
                <div style = {{display: 'flex', flexDirection: 'row', marginTop: '8px'}}>
                    <ThemeProvider theme = {blue_theme}>
                        {/* <Tooltip title = 'Back'>
                            <IconButton onClick = {this.handleBack} color = 'primary'>
                                <ArrowUpward/>
                            </IconButton>
                        </Tooltip> */}
                        <Tooltip title = 'Next'>
                            <IconButton onClick = {this.handleNext} color = 'primary'>
                                <ArrowDownward/>
                            </IconButton>
                        </Tooltip>
                    </ThemeProvider>
                </div>
            )
        }
    }

    render() {
        const { classes } = this.props
        return (
            <Paper square style = {{width : '100%', height: this.props.maxHeight + 'px', maxHeight: this.props.maxHeight + 'px'}} elevation = {4}>
                 <div ref = {this.headingPanel} style = {{backgroundColor : '#F0F0F0', padding : '8px',display : 'flex', flexDirection : 'row'}}>
                    <div style = {{flexGrow : 1, display: 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography variant = 'h6'>Add Parameters</Typography>
                        <Typography style = {{color : '#F50157', marginLeft: '10px'}} variant = 'caption'>{this.state.error_message}</Typography>
                    </div>
                    <ThemeProvider theme = {blue_theme}>
                        <Button 
                            variant = 'contained' 
                            color = 'primary'
                            disabled = {this.state.fields.length === 0 ? true : false}
                            onClick = {this.validateAndProceed}
                        >
                            Next
                        </Button>
                    </ThemeProvider>
                </div>
                { this.renderFields()}
            </Paper>
        );
    }
}

export default withStyles(styles)(SetSecurityCredentails);